import { render, staticRenderFns } from "./customerSubSettlementModel.vue?vue&type=template&id=9add7c4a&scoped=true&"
import script from "./customerSubSettlementModel.vue?vue&type=script&lang=js&"
export * from "./customerSubSettlementModel.vue?vue&type=script&lang=js&"
import style0 from "./customerSubSettlementModel.vue?vue&type=style&index=0&id=9add7c4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9add7c4a",
  null
  
)

export default component.exports